var map = {
	"./ABW.svg": 749,
	"./AFG.svg": 750,
	"./AFRICA.svg": 751,
	"./AGO.svg": 752,
	"./AIA.svg": 753,
	"./ALA.svg": 754,
	"./ALB.svg": 755,
	"./AND.svg": 756,
	"./ARE.svg": 757,
	"./ARG.svg": 758,
	"./ARM.svg": 759,
	"./ASIA.svg": 760,
	"./ATG.svg": 761,
	"./AUS.svg": 762,
	"./AUT.svg": 763,
	"./AZE.svg": 764,
	"./BDI.svg": 765,
	"./BEL.svg": 766,
	"./BEN.svg": 767,
	"./BFA.svg": 768,
	"./BGD.svg": 769,
	"./BGR.svg": 770,
	"./BHR.svg": 771,
	"./BHS.svg": 772,
	"./BLR.svg": 773,
	"./BLZ.svg": 774,
	"./BMU.svg": 775,
	"./BOL.svg": 776,
	"./BRA.svg": 777,
	"./BRB.svg": 778,
	"./BRN.svg": 779,
	"./BTN.svg": 780,
	"./BWA.svg": 781,
	"./CAF.svg": 782,
	"./CAN.svg": 783,
	"./CHE.svg": 784,
	"./CHL.svg": 785,
	"./CHN.svg": 786,
	"./CIV.svg": 787,
	"./CMR.svg": 788,
	"./COD.svg": 789,
	"./COG.svg": 790,
	"./COL.svg": 791,
	"./COM.svg": 792,
	"./CPV.svg": 793,
	"./CRI.svg": 794,
	"./CUB.svg": 795,
	"./CYM.svg": 796,
	"./CYP.svg": 797,
	"./CZE.svg": 798,
	"./DEU.svg": 799,
	"./DJI.svg": 800,
	"./DMA.svg": 801,
	"./DNK.svg": 802,
	"./DOM.svg": 803,
	"./DZ.svg": 804,
	"./ECU.svg": 805,
	"./EGY.svg": 806,
	"./ENG.svg": 807,
	"./ERI.svg": 808,
	"./ESP.svg": 809,
	"./EST.svg": 810,
	"./ETH.svg": 811,
	"./EUROPE.svg": 812,
	"./FIN.svg": 813,
	"./FJI.svg": 814,
	"./FLK.svg": 815,
	"./FRA.svg": 816,
	"./FRO.svg": 817,
	"./FSM.svg": 818,
	"./GAB.svg": 819,
	"./GBR.svg": 820,
	"./GEO.svg": 821,
	"./GGY.svg": 822,
	"./GHA.svg": 823,
	"./GIB.svg": 824,
	"./GIN.svg": 825,
	"./GMB.svg": 826,
	"./GNB.svg": 827,
	"./GNQ.svg": 828,
	"./GRC.svg": 829,
	"./GRD.svg": 830,
	"./GTM.svg": 831,
	"./GUY.svg": 832,
	"./Grupo 6584.svg": 833,
	"./HKG.svg": 834,
	"./HND.svg": 835,
	"./HRV.svg": 836,
	"./HTI.svg": 837,
	"./HUN.svg": 838,
	"./IDN.svg": 839,
	"./IMN.svg": 840,
	"./IND.svg": 841,
	"./IRL.svg": 842,
	"./IRN.svg": 843,
	"./IRQ.svg": 844,
	"./ISL.svg": 845,
	"./ISR.svg": 846,
	"./ITA.svg": 847,
	"./JAM.svg": 848,
	"./JEY.svg": 849,
	"./JOR.svg": 850,
	"./JPN.svg": 851,
	"./KAZ.svg": 852,
	"./KEN.svg": 853,
	"./KGZ.svg": 854,
	"./KHM.svg": 855,
	"./KNA.svg": 856,
	"./KOR.svg": 857,
	"./KOS.svg": 858,
	"./KWT.svg": 859,
	"./LAO.svg": 860,
	"./LBN.svg": 861,
	"./LBR.svg": 862,
	"./LBY.svg": 863,
	"./LCA.svg": 864,
	"./LIE.svg": 865,
	"./LKA.svg": 866,
	"./LSO.svg": 867,
	"./LTU.svg": 868,
	"./LUX.svg": 869,
	"./LVA.svg": 870,
	"./MAC.svg": 871,
	"./MAR.svg": 872,
	"./MCO.svg": 873,
	"./MDA.svg": 874,
	"./MDG.svg": 875,
	"./MDV.svg": 876,
	"./MEX.svg": 877,
	"./MKD.svg": 878,
	"./MLI.svg": 879,
	"./MLT.svg": 880,
	"./MMR.svg": 881,
	"./MNE.svg": 882,
	"./MNG.svg": 883,
	"./MOZ.svg": 884,
	"./MRT.svg": 885,
	"./MSR.svg": 886,
	"./MUS.svg": 887,
	"./MWI.svg": 888,
	"./MYS.svg": 889,
	"./NAM.svg": 890,
	"./NER.svg": 891,
	"./NGA.svg": 892,
	"./NIC.svg": 893,
	"./NIR.svg": 894,
	"./NLD.svg": 895,
	"./NOR.svg": 896,
	"./NORTH AMERICA.svg": 897,
	"./NPL.svg": 898,
	"./NZL.svg": 899,
	"./OCEANIA.svg": 900,
	"./OMN.svg": 901,
	"./PAK.svg": 902,
	"./PAN.svg": 903,
	"./PER.svg": 904,
	"./PHL.svg": 905,
	"./PLW.svg": 906,
	"./PNG.svg": 907,
	"./POL.svg": 908,
	"./PRI.svg": 909,
	"./PRK.svg": 910,
	"./PRT.svg": 911,
	"./PRY.svg": 912,
	"./PYF.svg": 913,
	"./QAT.svg": 914,
	"./ROU.svg": 915,
	"./RUS.svg": 916,
	"./RWA.svg": 917,
	"./SAU.svg": 918,
	"./SCO.svg": 919,
	"./SDN.svg": 920,
	"./SEN.svg": 921,
	"./SGP.svg": 922,
	"./SLB.svg": 923,
	"./SLE.svg": 924,
	"./SLV.svg": 925,
	"./SMR.svg": 926,
	"./SOM.svg": 927,
	"./SOUTH AMERICA.svg": 928,
	"./SRB.svg": 929,
	"./STP.svg": 930,
	"./SUR.svg": 931,
	"./SVK.svg": 932,
	"./SVN.svg": 933,
	"./SWE.svg": 934,
	"./SWZ.svg": 935,
	"./SYC.svg": 936,
	"./SYR.svg": 937,
	"./TCA.svg": 938,
	"./TGO.svg": 939,
	"./THA.svg": 940,
	"./TJK.svg": 941,
	"./TKM.svg": 942,
	"./TLS.svg": 943,
	"./TON.svg": 944,
	"./TTO.svg": 945,
	"./TUN.svg": 946,
	"./TUR.svg": 947,
	"./TWN.svg": 948,
	"./TZA.svg": 949,
	"./UE.svg": 950,
	"./UGA.svg": 951,
	"./UKR.svg": 952,
	"./URY.svg": 953,
	"./USA.svg": 954,
	"./UZB.svg": 955,
	"./VCT.svg": 956,
	"./VEN.svg": 957,
	"./VGB.svg": 958,
	"./VNM.svg": 959,
	"./VUT.svg": 960,
	"./WAL.svg": 961,
	"./WORLDWIDE.svg": 485,
	"./WSM.svg": 962,
	"./YEM.svg": 963,
	"./ZAF.svg": 964,
	"./ZMB.svg": 965,
	"./ZWE.svg": 966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;